<template>
  <button
    @click="click"
    :disabled="disabled || loading"
    :type="type"
    :class="{ [$style.primary]: !reverse, [$style.primaryReverse]: reverse }"
  >
    <span :class="$style.label">
      <loader v-if="loading" :class="$style.loader" />
      <slot></slot>
    </span>
  </button>
</template>

<script>
import Loader from '@/components/Loader'
export default {
  components: { Loader },

  props: {
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    reverse: { type: Boolean, default: false },
    type: { type: String, default: 'button' }
  },

  methods: {
    click() {
      return this.$emit('click')
    }
  }
}
</script>

<style lang="scss" module>
.primary {
  @include primary-btn;
}

.primaryReverse {
  @include primary-btn(true);
}

.label {
  display: flex;
  align-items: center;
  justify-content: center;
}

.loader {
  margin-left: spacing(-1);
  margin-right: spacing(0.5);
}
</style>
